$(document).on('click', "[data-behavior='sf-freshdesk-help-launcher']", (e) => {
  e.preventDefault()

  window.FreshworksWidget('open')

  if (window.fcWidget) {
    window.fcWidget.close()
  }
})

$(document).on(
  'click',
  "[data-behavior='sf-freshdesk-chat-launcher-new-window']",
  (e) => {
    e.preventDefault()

    const url = e.currentTarget.href
    window.open(
      url,
      '_blank',
      'location=no,height=570,width=520,toolbar=no,menubar=no,scrollbars=yes,status=yes'
    )
  }
)

$(document).on('click', "[data-behavior='launch-freshdesk-chat']", (e) => {
  e.preventDefault()

  if (window.fcWidget) {
    window.fcWidget.open()
  }
})
